import React from 'react';
import { TableList, Typography } from 'seagull';
import ViewInvoice from "../components/ViewInvoice/ViewInvoice";
import VendorNameLink from "../components/VendorNameLink/VendorNameLink";
import { RequiresApproval } from "./types";
const FutureInvoiceRow = _ref => {
  let {
    testId,
    futureInvoice
  } = _ref;
  const displayedAgreementName = futureInvoice.displayedAgreementName();
  const items = [{
    value: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(VendorNameLink, {
      testid: "".concat(testId, "-company-name"),
      vendorName: futureInvoice.companyName(),
      relationshipID: futureInvoice.relationshipId()
    }), displayedAgreementName && /*#__PURE__*/React.createElement(Typography, {
      skin: "secondary",
      "data-testid": "".concat(testId, "-agreement-name"),
      ellipsis: true
    }, displayedAgreementName))
  }, {
    value: /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "".concat(testId, "-issue-date")
    }, futureInvoice.issueDate())
  }, {
    value: /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "".concat(testId, "-due-date")
    }, futureInvoice.dueDate())
  }, {
    value: /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "".concat(testId, "-requires-approval")
    }, futureInvoice.requiresApproval() ? RequiresApproval.Yes : RequiresApproval.No)
  }, {
    value: /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "".concat(testId, "-total")
    }, futureInvoice.total())
  }, {
    value: /*#__PURE__*/React.createElement(ViewInvoice, {
      relationshipID: futureInvoice.relationshipId(),
      date: futureInvoice.rawIssueDate(),
      testid: "".concat(testId, "-view-invoice")
    })
  }];
  return /*#__PURE__*/React.createElement(TableList.Row, {
    "data-testid": testId,
    items: items
  });
};
export default FutureInvoiceRow;